import {
  DepositGatewayVerify,
  DepositGatewayVerifyJibimo,
} from "store/api/deposit";

export const PAYMENT_GATEWAYS = {
  vandar: {
    keys: ["token", "payment_status"],
    api: DepositGatewayVerify,
  },
  jimbo: {
    api: DepositGatewayVerifyJibimo,
    keys: [
      "trx",
      "status",
      "state_code",
      "amount",
      "original_amount",
      "wage",
      "order_number",
      "full_name",
    ],
  },
};
